<template>
  <div
    class="html-renderer"
    :style="computedStyle"
    v-html="content"
  />
</template>

<script>
export default {
  name: "KvHtmlRenderer",

  props: {
    content: {
      type: String,
      required: true,
    },
    height: {
      type: [String, Number],
      default: null,
    },
    maxHeight: {
      type: [String, Number],
      default: null,
    },
  },

  computed: {
    computedStyle() {
      const style = {
        overflow: "auto",
      };

      if (this.height) {
        style.height =
          typeof this.height === "number"
            ? `${this.height}px`
            : this.height;
      }

      if (this.maxHeight) {
        style.maxHeight =
          typeof this.maxHeight === "number"
            ? `${this.maxHeight}px`
            : this.maxHeight;
      }

      return style;
    },
  },
};
</script>

<style scoped>
.html-renderer {
  width: 100%;
  box-sizing: border-box;

  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 8px;
}
</style>
